import React from "react";
import { Navbar } from "react-bootstrap";
import Footer from "../../components/Footer";

const TermsPolicy = () => {
  return (
    <>
      <Navbar />
      <section className="privacy_sec">
        <div className="container">
          <div className="privacy_content">
            <h1>Terms & Policies</h1>
            <h5>Intellectual Property</h5>
            <p>
              All content and materials available on our website, including but
              not limited to text, graphics, logos, button icons, images, audio
              clips, data compilations, and software, are the property of Teedex
              and protected by international copyright laws.
            </p>

            <h5>User Conduct</h5>
            <p>
              Users agree to use our website for lawful purposes and not to
              violate any laws, infringe upon the rights of others, or interfere
              with the operation of the site.
            </p>

            <h5>Modifications </h5>
            <p>
              We reserve the right to revise and update these Terms & Policies
              at any time without notice. By using this website, you agree to be
              bound by the current version of these Terms & Policies.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default TermsPolicy;
